import React from 'react';
import { NumberProperty } from './types';

type Props = {
  property: NumberProperty;
};

export function NumberPropertyValue({ property }: Props) {
  const { number, unit } = property;

  if (number === null) {
    return null;
  }

  if (unit === null) {
    return <>{number}</>;
  }

  return <>{`${number}\u00A0${unit}`}</>;
}
